import { TableCell, TableRow } from "components/table";
import { Skeleton } from "components/skeleton";

export const ThemaCodesTableSkeletonRows = ({
  level,
  notationColumnWidth,
  rowCount = 5,
  flatLayout = false,
}: {
  level: number;
  notationColumnWidth: number;
  rowCount?: number;
  flatLayout?: boolean;
}) => {
  // Remove indentation in flat layout mode since results are flattened
  const indentValue = flatLayout ? 0 : level;
  const indentStyle = { paddingLeft: `${(indentValue + 1) * 16}px` };
  const getSkeletonWidthClass = (index: number) => {
    if (index % 5 === 0) return "w-64";
    if (index % 5 === 1) return "w-48";
    if (index % 5 === 2) return "w-56";
    if (index % 5 === 3) return "w-72";
    return "w-40";
  };

  return Array.from({ length: rowCount }, (_, i) => (
    <TableRow
      // biome-ignore lint/suspicious/noArrayIndexKey: skeleton rows are positional placeholders
      key={`skeleton-row-${level}-${i + 1}`}
      className="animate-pulse"
      data-testid={`skeleton-row-level-${level}`}
    >
      <TableCell
        className="py-3"
        style={{ ...indentStyle, width: `${notationColumnWidth}px` }}
      >
        <Skeleton className="h-4 w-12 bg-secondary-200" />
      </TableCell>
      <TableCell className="py-3">
        <div className="flex items-center space-x-4">
          <Skeleton
            className={`h-4 bg-secondary-200 ${getSkeletonWidthClass(i)}`}
          />
          {i < 3 && <Skeleton className="h-3 w-3 rounded bg-secondary-200" />}
        </div>
      </TableCell>
      <TableCell className="py-3 text-right w-12 px-8">
        <Skeleton className="h-4 w-4 rounded bg-secondary-200 ml-auto" />
      </TableCell>
    </TableRow>
  ));
};
